<template>
  <CContainer
    class="d-flex align-items-center justify-content-center min-vh-100"
  >
    <CRow class="justify-content-center">
      <CCard
        text-color="white"
        class="text-center py-5"
        style="width:680px;background-color:#409EFF"
        body-wrapper
      >
        <h3>月光個人音檔管理系統</h3>
        <div>版本：1.0.0</div>
      </CCard>
    </CRow>
  </CContainer>
</template>

<script>
import { mapGetters } from "vuex";
import { SYS_ADMIN_ROLE, ROUTENAME, ORG_ADMIN_ROLE, DEPT_ADMIN_ROLE, CHNL_ADMIN_ROLE, GBL_CHNL_ADMIN_ROLE } from "../appConfig";
export default {
  name: "Login",
  computed: {
    ...mapGetters({
      myRoles: "auth/roles",
    }),
  },
  created() {
    setTimeout(() => {
      this.autoRedirect();
    }, 1500);
  },
  methods: {
    autoRedirect() {
      if (this.myRoles.includes(SYS_ADMIN_ROLE)) {
        this.$router.push({ name: ROUTENAME.GBL });
      }
      else if (this.myRoles.includes(GBL_CHNL_ADMIN_ROLE)) {
        this.$router.push({ name: ROUTENAME.GBLCHNL });
      }
      else if (this.myRoles.includes(ORG_ADMIN_ROLE)) {
        this.$router.push({ name: ROUTENAME.ORG });
      }
      else if (this.myRoles.includes(DEPT_ADMIN_ROLE)) {
        this.$router.push({ name: ROUTENAME.DEPT });
      }
      else if (this.myRoles.includes(CHNL_ADMIN_ROLE)) {
        this.$router.push({ name: ROUTENAME.CHNL });
      }
    },
  },
};
</script>
